import React from 'react';
import PropTypes from 'prop-types';
import Modal from 'react-modal';

const SendProgressModal = ({ isOpen, totalToSend = 0, totalSent = 0 }) => {
	return (
		<Modal isOpen={isOpen} contentLabel="Campaign Notifications Sent" className="modal-dialog modal-sm send-progress-modal">
			<div className="modal-content">
				<div className="modal-header">
					<div className="clearfix">
						<h3 className="modal-title">
							Campaign Notifications Sent
						</h3>
					</div>
				</div>
				<div className="modal-body">
					<div className="progress progress-xs">
						<div
							role="progressbar"
							aria-valuenow={totalSent}
							aria-valuemin="0"
							aria-valuemax={totalToSend}
							className="progress-bar progress-bar-info"
							style={{ width: totalToSend > 0 ? `${(totalSent / totalToSend) * 100}%` : '100%' }}
						>
							<span className="sr-only">{totalSent} of {totalToSend} Sent</span>
						</div>
					</div>
				</div>
			</div>
		</Modal>
	);
};

SendProgressModal.propTypes = {
	isOpen: PropTypes.bool,
	totalToSend: PropTypes.number,
	totalSent: PropTypes.number
};

export default SendProgressModal;
